import React from "react";

export const LandingPageLazy = React.lazy(() => import("./index"));
